export enum RouterIndex {
  Home = 0,
  None = -1,
  Digitizing = 1,
  Management = 2,
  Generation = 3,
}
